/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_O1_Point_1_LabelInputs */

const en_visa_o1_point_1_label = /** @type {(inputs: Visa_O1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field-Specific Strategy`)
};

const pt_visa_o1_point_1_label = /** @type {(inputs: Visa_O1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia Específica do Campo`)
};

const es_visa_o1_point_1_label = /** @type {(inputs: Visa_O1_Point_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia Específica del Campo`)
};

/**
* | output |
* | --- |
* | "Field-Specific Strategy" |
*
* @param {Visa_O1_Point_1_LabelInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_o1_point_1_label = /** @type {((inputs?: Visa_O1_Point_1_LabelInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_O1_Point_1_LabelInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_o1_point_1_label(inputs)
	if (locale === "es") return es_visa_o1_point_1_label(inputs)
	return en_visa_o1_point_1_label(inputs)
});